import * as coreLine     from './coreLine';

export default ({
  coreLine,
});